<div class="PGChat bg-white">
    @if (!isLoggedIn) {
        <div class="PGChat-Login">
            @if (authorizationToken == null) {
                <div class="form-group mb-3">
                    <label>
                        <b>Guest name</b>
                    </label>
                    <input class="form-control" [(ngModel)]="unathorizedName" (keyup)="onUnathorizedNameKeyUp($event)"/>
                </div>
                <button class="btn btn-primary btn-block" [disabled]="canUnauthorizedLogIn()" (click)="unauthorizedLogIn()">Login as Guest</button>
            }
        </div>
    }
    @if (isLoggedIn) {
        @if (isLoading) {
            <app-pg-loading></app-pg-loading>
        }
        @if (!isLoading) {
            @if (hasAccessError) {
                <div class="text-danger">ERROR</div>
            }
            @if (!hasAccessError) {
                <div class="PGChat-Outer">
                    @if (callChannel != null) {
                        <div class="PGChat-Call {{ callCompressed ? 'PGChat-Call--Compressed border-bottom' : '' }} bg-white">
                            <div class="PGChat-Call-Header bg-light border-bottom p-1">
                                <div class="ps-2">{{ getChannelName(callChannel) }}</div>
                                @if (callConfirmed) {
                                    <div>
                                        <button class="btn btn-{{callAudioDisabled ? 'danger' : 'light'}} btn-sm" (click)="callAudioDisabled = !callAudioDisabled">
                                            <i class="fa-regular fa-microphone-slash"></i>
                                        </button>
                                        <button class="btn btn-{{callVideoDisabled ? 'danger' : 'light'}} btn-sm" (click)="callVideoDisabled = !callVideoDisabled">
                                            <i class="fa-regular fa-video-slash"></i>
                                        </button>
                                        <button class="btn btn-light btn-sm {{callCompressed ? 'text-primary' : ''}}" (click)="callCompressed = !callCompressed">
                                            <i class="fa-regular fa-message-lines"></i>
                                        </button>
                                        <button class="btn btn-light btn-sm" (click)="leaveCurrentCall()">
                                            <i class="fa-regular fa-phone-hangup text-danger"></i>
                                        </button>
                                    </div>
                                }
                            </div>
                            <div class="PGChat-Call-Frame">
                                <!-- TODO: questa parte della conferma andrebbe rifattorizzata nel componente della call -->
                                @if (!callConfirmed) {
                                    <div class="PGChat-Call-Confirm">
                                        <div>
                                            <h4 class="px-3 mb-4">You are about to join a video call</h4>
                                        </div>
                                        <div class="d-flex">
                                            <div>
                                                <button class="btn btn-{{callAudioDisabled ? 'danger' : 'light'}}" (click)="callAudioDisabled = !callAudioDisabled" [disabled]="callAudioDevicesOptions.length == 0">
                                                    <i class="fa-regular fa-fw fa-microphone{{callAudioDisabled ? '-slash' : ''}}"></i>
                                                    <span>Audio</span>
                                                </button>
                                            </div>
                                            <div class="ps-2">
                                                <app-pg-select [required]="true" [options]="callAudioDevicesOptions" [(ngModel)]="callAudioSource" display="oneLine"></app-pg-select>
                                            </div>
                                        </div>
                                        <div class="d-flex">
                                            <div>
                                                <button class="btn btn-{{callVideoDisabled ? 'danger' : 'light'}}" (click)="callVideoDisabled = !callVideoDisabled" [disabled]="callVideoDevicesOptions.length == 0">
                                                    <i class="fa-regular fa-fw fa-video{{callVideoDisabled ? '-slash' : ''}}"></i>
                                                    <span>Video</span>
                                                </button>
                                            </div>
                                            <div class="ps-2">
                                                <app-pg-select [required]="true" [options]="callVideoDevicesOptions" [(ngModel)]="callVideoSource" display="oneLine"></app-pg-select>
                                            </div>
                                        </div>
                                        <div class="mt-4">
                                            <button class="btn btn-secondary me-1" (click)="callConfirmed = true">
                                                <i class="fa-regular fa-fw fa-phone-hangup"></i>
                                                <span>Leave</span>
                                            </button>
                                            <button class="btn btn-primary ms-1" (click)="callConfirmed = true">
                                                <i class="fa-regular fa-fw fa-phone"></i>
                                                <span>Join</span>
                                            </button>
                                        </div>
                                    </div>
                                }
                                @if (callConfirmed) {
                                    <app-pg-call [callToken]="callToken" [callChannel]="callChannel" [callURL]="callURL" [disableAudio]="callAudioDisabled" [disableVideo]="callVideoDisabled" [audioSource]="callAudioSource" [videoSource]="callVideoSource"></app-pg-call>
                                }
                            </div>
                        </div>
                    }
                    <div class="PGChat-Middle">
                        @if (!isGuest) {
                            <div class="PGChat-Tabs d-flex justify-content-between border-bottom bg-light">
                                <div class="PGChat-Tabs-Main ps-2 pt-1">
                                    <ul class="nav nav-tabs">
                                        <li class="nav-item">
                                            <a class="nav-link {{currentTab == 'chat' ? 'active' : ''}}" (click)="setCurrentTab('chat')">Chat</a>
                                        </li>
                                        @if (isCustomerCareEnabled()) {
                                            <li class="nav-item">
                                                <a class="nav-link {{currentTab == 'customer_care' ? 'active' : ''}} {{customerCareBlink ? 'PGChat-Tabs-Main-Item--Blink' : ''}}" (click)="setCurrentTab('customer_care')">
                                                    CustomerCare<span class="badge bg-{{ customerCareWaitList.length == 0 ? 'light' : 'danger'}} ms-1">{{customerCareWaitList.length}}</span>
                                                </a>
                                            </li>
                                        }
                                    </ul>
                                </div>
                                <div class="PGChat-Tabs-Buttons pe-2 ps-1 pt-1">
                                    <!--<button class="btn btn-link px-2">
                                    <i class="fa-regular fa-volume"></i>
                                </button>
                                <button class="btn btn-link px-2">
                                    <i class="fa-regular fa-message"></i>
                                </button>-->
                            </div>
                        </div>
                    }
                    <div class="PGChat-Inner">
                        @if (showChannels && !isGuest) {
                            <div class="PGChat-Channels p-2 border-end pg-animation-slideright">
                                @if (currentTab == 'chat') {
                                    @for (channel of channelList; track channel) {
                                        @if (!isGuestChannel(channel) && !isCustomerCareChannel(channel) && !isDirectChannel(channel)) {
                                            <ng-container *ngTemplateOutlet="channelButtonTemplate;context:{ channel: channel }"></ng-container>
                                        }
                                    }
                                    @for (channel of channelList; track channel) {
                                        @if (isDirectChannel(channel)) {
                                            <ng-container *ngTemplateOutlet="channelButtonTemplate;context:{ channel: channel }"></ng-container>
                                        }
                                    }
                                    <div class="PGChat-Channels-Add" ngbDropdown #joinChannelMenu="ngbDropdown" [autoClose]="'outside'">
                                        <button ngbDropdownToggle class="btn btn-light btn-sm">
                                            <i class="fa-regular fa-plus"></i>
                                        </button>
                                        <div ngbDropdownMenu class="PGChat-Channels-Add-Channel-Menu">
                                            <div class="dropdown-item-text">
                                                <label>Join channel</label>
                                                <div class="input-group">
                                                    <input class="form-control form-control-sm" [(ngModel)]="joinChannelId" (keyup)="onJoinChannelIdKeyUp($event)"/>
                                                    <div class="input-group-append">
                                                        <button class="btn btn-sm btn-primary" (click)="joinChannel()">
                                                            <i class="fa-regular fa-sign-in"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                            @if (userList.length > 0) {
                                                <div class="dropdown-item-text">Chat with user</div>
                                                @for (user of userList; track user) {
                                                    <button class="dropdown-item btn btn-sm btn-light" (click)="onChatWithUserClick(user)">
                                                        <i class="fa fa-xs fa-circle text-{{getUserStatusClass(user)}} me-1"></i><span>{{ getUserName(user) }}</span>
                                                    </button>
                                                }
                                            }
                                        </div>
                                    </div>
                                }
                                @if (currentTab == 'customer_care') {
                                    @for (channel of channelList; track channel) {
                                        @if (isCustomerCareChannel(channel)) {
                                            <ng-container *ngTemplateOutlet="channelButtonTemplate;context:{ channel: channel }"></ng-container>
                                        }
                                    }
                                    @for (channel of channelList; track channel) {
                                        @if (isGuestChannel(channel)) {
                                            <ng-container *ngTemplateOutlet="channelButtonTemplate;context:{ channel: channel }"></ng-container>
                                        }
                                    }
                                    @if (customerCareWaitList.length > 0) {
                                        <div class="PGChat-Channels-Item mb-2">
                                            Waiting
                                        </div>
                                        @for (user of customerCareWaitList; track user) {
                                            <div class="PGChat-Channels-Item mb-2">
                                                <button class="btn btn-sm btn-light" (click)="openDirectOrGuestChannel(user)">
                                                    <i class="fa fa-xs fa-circle text-{{getUserStatusClass(user)}} me-1"></i><span>{{ getUserName(user) }}</span>
                                                </button>
                                            </div>
                                        }
                                    }
                                    @if (customerCareBookingsDay != null) {
                                        <div class="PGChat-Channels-Item mb-2">
                                            Bookings
                                        </div>
                                        @for (item of customerCareBookingsDay | keyvalue; track item) {
                                            <div class="mb-2" ngbDropdown>
                                                <button ngbDropdownToggle class="btn btn-light btn-sm">
                                                    <span>{{item.key}}</span>
                                                    @if (customerCareBookingStatus[item.value.pid]; as status) {
                                                        @if (status.guest.user != null) {
                                                            <i class="fa fa-xs fa-circle text-{{getUserStatusClass(status.guest.user)}} me-1"></i>
                                                        }
                                                    }
                                                </button>
                                                <div ngbDropdownMenu>
                                                    <div style="max-height: 400px; overflow: auto;">
                                                        <b>STATUS</b>
                                                        @if (customerCareBookingStatus[item.value.pid]; as status) {
                                                            <pre>{{status | json}}</pre>
                                                        }
                                                        <b>BOOKING</b>
                                                        <pre>{{item.value | json}}</pre>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    }
                                    <div class="PGChat-Channels-Add" ngbDropdown (openChange)="onGuestSessionsOpenChange($event)">
                                        <button ngbDropdownToggle class="btn btn-light btn-sm">
                                            <i class="fa-regular fa-history"></i>
                                        </button>
                                        <div ngbDropdownMenu class="PGChat-Channels-Add-GuestSession-Menu">
                                            @if (isLoadingGuestSessions) {
                                                <app-pg-loading></app-pg-loading>
                                            }
                                            @if (!isLoadingGuestSessions) {
                                                @for (session of guestSessions; track session) {
                                                    <button class="dropdown-item btn" (click)="joinGuestSession(session)">
                                                        <div>
                                                            <i class="fa fa-xs fa-circle text-{{getSessionStatusClass(session)}} me-1"></i>
                                                            <span>{{session.username}}</span>
                                                            <small class="ms-1">{{getSessionDateTime(session)}}</small>
                                                        </div>
                                                        <div class="text-muted">
                                                            <small>Session ID: {{session.session_id}}</small>
                                                        </div>
                                                    </button>
                                                }
                                            }
                                        </div>
                                    </div>
                                }
                            </div>
                        }
                        <div class="PGChat-CurrentChannel">
                            @if (channels[getCurrentChannel()]; as channel) {
                                <div class="PGChat-CurrentChannel-Header p-1 border-bottom">
                                    <div class="PGChat-CurrentChannel-Header-Title">
                                        @if (!isGuest) {
                                            <button class="btn btn-sm btn-light text-{{ showChannels ? 'primary' : '' }}" (click)="showChannels = !showChannels">
                                                <i class="fa-regular fa-bars"></i>
                                                @if (getUnreadSum(); as unread) {
                                                    <span class="badge bg-danger">{{ unread }}</span>
                                                }
                                            </button>
                                            @if (!showChannels) {
                                                <div class="ps-2 PGChat-CurrentChannel-Header-Title-Text">{{ getChannelName(getCurrentChannel()) }}</div>
                                            }
                                        }
                                    </div>
                                    <div class="PGChat-CurrentChannel-Header-Actions">
                                        @if (channel.status != null && channel.status.users != null) {
                                            <button class="btn btn-sm {{ callChannel == getCurrentChannel() ? 'btn-primary' : ('btn-light' + (getCallParticipantsCount(channel.status) > 0 ? ' text-primary' : '')) }}" (click)="joinCallCurrentChannel()" title="{{getCallParticipantsList(channel.status)}}">
                                                <i class="fa-regular fa-phone"></i> {{getCallParticipantsCount(channel.status)}}
                                            </button>
                                            @if (channel.status != null && channel.status.users != null) {
                                                <span ngbDropdown>
                                                    <button  class="btn btn-sm btn-light" ngbDropdownToggle>
                                                        <i class="fa-regular fa-users"></i> {{channel.status.users.length}}
                                                    </button>
                                                    <div ngbDropdownMenu>
                                                        @for (user of channel.status.users; track user) {
                                                            <button class="dropdown-item btn btn-sm btn-light" (click)="openDirectOrGuestChannel(user)">
                                                                <i class="fa fa-xs fa-circle text-{{getUserStatusClass(user)}} me-1"></i><span>{{ getUserName(user) }}</span>
                                                            </button>
                                                        }
                                                    </div>
                                                </span>
                                            }
                                        }
                                        @if (!isGuest && !isCustomerCareChannel(getCurrentChannel())) {
                                            <button class="btn btn-sm btn-light" (click)="leaveCurrentChannelOrDirect()">
                                                <i class="fa-regular fa-sign-out"></i>
                                            </button>
                                        }
                                    </div>
                                </div>
                                <div class="PGChat-CurrentChannel-Content">
                                    @if (channel.status != null) {
                                        <div class="PGChat-CurrentChannel-Content-Main">
                                            <div #messagesElement class="PGChat-CurrentChannel-Content-Main-Messages py-1 px-2">
                                                @for (message of channel.status.messages; track message; let i = $index) {
                                                    @if (hasMessageDate(channel.status.messages, i)) {
                                                        <div class="text-muted border-bottom mb-2">
                                                            <small class="text-muted">{{ getMessageDate(message) }}</small>
                                                        </div>
                                                    }
                                                    <div class="mb-2">
                                                        @if (hasMessageUserAndTime(channel.status.messages, i)) {
                                                            <div>
                                                                <b class="me-2">{{ getUserName(message.from) }}</b>
                                                                <small class="text-muted">{{ getMessageTime(message) }}</small>
                                                            </div>
                                                        }
                                                        @if (message.content != null && message.content != '') {
                                                            <div class="PGChat-CurrentChannel-Content-Main-Messages-Content">
                                                                <span>{{ message.content }}</span>
                                                            </div>
                                                        }
                                                        @if (message.data != null) {
                                                            <div>
                                                                @if (message.data.type == 'attachment') {
                                                                    <div>
                                                                        <a target="_blank" [href]="message.data.url | safe:'url'">
                                                                            <i class="fa-regular fa-paperclip"></i>
                                                                            <span class="ms-1">{{message.data.name}}</span>
                                                                        </a>
                                                                    </div>
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                            <div class="PGChat-CurrentChannel-Content-Main-Input border-top">
                                                @if (getCurrentChannelTyping(); as typing) {
                                                    <div class="PGChat-CurrentChannel-Content-Main-Input-Typing small bg-white border rounded px-1">
                                                        <span class="PGChat-CurrentChannel-Content-Main-Input-Typing-Icon me-1">
                                                            <i class="fa fa-circle"></i>
                                                            <i class="fa fa-circle"></i>
                                                            <i class="fa fa-circle"></i>
                                                        </span>
                                                        @for (item of typing | keyvalue; track item) {
                                                            <span>{{getUserName(item.key)}}</span>
                                                        }
                                                    </div>
                                                }
                                                <div class="d-flex">
                                                    <input class="form-control border-0" [(ngModel)]="editMessageText" (keyup)="onEditMessageTextKeyUp($event)" [disabled]="isSaving"/>
                                                    @if (!isGuest) {
                                                        <div class="border-start">
                                                            <button class="btn btn-link PGChat-CurrentChannel-Content-Main-Input-Attachment" [disabled]="isSaving">
                                                                <i class="fa-regular fa-paperclip m-0"></i>
                                                                <app-pg-upload-button [overlay]="true" [disabled]="isSaving" (setFiles)="setFiles($event)"></app-pg-upload-button>
                                                            </button>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        }
    }
}
</div>

<ng-template #channelButtonTemplate let-channel="channel">
    <div class="PGChat-Channels-Item mb-2">
        <button class="btn btn-sm btn-{{ channel == getCurrentChannel() ? 'primary' : 'light' }}" (click)="setCurrentChannel(channel);">
            @if (getChannelStatusClass(channel); as status) {
                <i class="fa fa-xs fa-circle text-{{status}} me-1"></i>
            }
            <span>{{ getChannelName(channel) }}</span>
            @if (channels[channel].unread) {
                <span class="badge bg-danger">{{ channels[channel].unread }}</span>
            }
        </button>
    </div>
</ng-template>